<template>
  <div class="item-detail-navigator">
    <remote-control-button
      :tooltip-placement="tooltipPlacement"
      tooltip-text="Back"
      icon-name="arrow-left"
      @click="$emit('back-button-clicked')"
    />
    <prev-next-arrows
      :class="{'ghost' : !(fromAll || fromEntityLanding)}"
      :previous-item="previousItem"
      :next-item="nextItem"
      :stack-vertically="$screen.isTabletOrDesktop($mq)"
      :tooltip-placement="tooltipPlacement"
      @navigate="(item) => $emit('navigate', item)"
    />
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import BreadcrumbAssistant from '@/helpers/breadcrumb-assistant'

/* Data types */
import { IBreadcrumbItemMenuItem } from '@/types/data-objects/items'

/* API */

export default defineComponent({
  name: 'ItemDetailNavigator',

  props: {
    currentRefNumber: {
      type: Number,
      default: null,
    },
  },

  emits: ['back-button-clicked', 'navigate'],

  computed: {
    tooltipPlacement(): string {
      return this.$screen.isMobile(this.$mq) ? 'bottom' : 'right'
    },
    fromAll(): boolean | any {
      return BreadcrumbAssistant.fromAll(this.$route)
    },
    fromEntityLanding(): boolean | any {
      return BreadcrumbAssistant.fromEntityLanding(this.$route)
    },
    previousItem(): IBreadcrumbItemMenuItem {
      return BreadcrumbAssistant.getPreviousBreadcrumbItem(
        this.currentRefNumber
      )
    },
    nextItem(): IBreadcrumbItemMenuItem {
      return BreadcrumbAssistant.getNextBreadcrumbItem(
        this.currentRefNumber
      )
    },
  },
})
</script>

<style lang="scss">
.item-detail-navigator {
  display: flex;
  justify-content: space-between;
  position: sticky;
  top: 70px;
  width: 100%;
  margin-top: 6px;

  > :first-child {
    margin-left: -44px;
  }

  > :last-child {
    margin-right: -44px;
  }

  > .ghost {
    visibility: hidden;
  }

  @include media-breakpoint-down(md) {
    > :first-child {
      margin-left: -40px;
    }

    > :last-child {
      margin-right: -40px;
    }
  }

  @include media-breakpoint-down(sm) {
    position: absolute;
    flex-direction: row;
    width: fit-content;
    margin-left: 0;
    left: 58px;
    top: -150px;
    z-index: 1050;

    @include flex-row-horizontal-spacing(10px);
  }
}
</style>
